import { AppState, RootState } from '@/types/store';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';
import { ConfirmationData } from '@/types/types';
import { Observable } from 'apollo-link';
import { AppEventNotification } from '@/types/graphql/schemaTypes';
import baseService from '@/services/BaseService';
import appEventSubscriptionQuery from '@/graphql/subscriptions/AppEventNotification.gql';

// initial state
const state: AppState = {
  confirmationModalData: null,
  eventSubscription: null,
  newContentAvailable: false,
  etag: null
};

// getters
const getters: GetterTree<AppState, RootState> = {
  confirmationModalData: aState => aState.confirmationModalData
};

// actions
const actions: ActionTree<AppState, RootState> = {
  openConfirmationModal({ commit }, data: ConfirmationData) {
    commit('setConfirmationModalData', data);
  },
  setNewContentAvailable({ commit }, value: boolean) {
    commit('setNewContentAvailable', value);
  },
  updateEtag({ state, commit, dispatch }, value: string) {
    if (state.etag && state.etag !== value) {
      dispatch('setNewContentAvailable', true);
    }
    commit('updateEtag', value);
  }
};

// mutations
const mutations: MutationTree<AppState> = {
  setConfirmationModalData(appState: AppState, confirmationData: ConfirmationData) {
    appState.confirmationModalData = confirmationData;
  },
  setNewContentAvailable: (appState: AppState, value: boolean) => {
    appState.newContentAvailable = value;
  },
  updateEtag: (appState: AppState, value: string) => {
    appState.etag = value;
  }
};

export const app: Module<AppState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
